function getOpt(data, selfValue, isSpecial) {
  console.log("aaaaaaaa", data);
  let yData = data.value || [];
  let xData = data.key || [];
  let avg = 0;
  if (yData.length && yData[1]) {
    avg = yData[1];
    yData[1] = selfValue;
  }
  isSpecial ? is89SpecialHandle(yData) : ''
  xData.forEach((item, i) => {
    if (item == "min") {
      xData[i] = "行业最小值";
    } else if (item == "avg") {
      xData[i] = "本企业";
    } else if (item == "max") {
      xData[i] = "行业最大值";
    }
  });
  return {
    tooltip: {
      show: true,
      trigger: "axis",
      backgroundColor: "rgba(4, 21, 39, 1)",
      borderWidth: 0,
      textStyle: {
        color: "#fff",
      },
    },
    xAxis: {
      type: "category",
      axisLabel: {
        color: "#D7D7D7",
        fontSize: 14, //bar字体设置
        interval: 0,
      },
      splitLine: {
        show: false,
      },
      axisLine: {
        lineStyle: {
          color: "#093E95",
          width: 1,
        },
      },
      axisTick: {
        show: false,
      },
      data: xData,
    },
    yAxis: {
      type: "value",
      // name: '万吨',
      nameTextStyle: {
        color: "#fff",
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: "#093E95",
        },
      },
      splitLine: {
        show: false,
      },
      axisLabel: {
        color: "#D7D7D7",
        fontSize: 14, //bar字体设置
      },
    },
    grid: {
      left: "15%",
      top: "15%",
      // width: 500,
      // height: 120
    },
    series: [
      {
        data: yData,
        barWidth: 40, //柱图宽度
        type: "bar",
        itemStyle: {
          barBorderRadius: [4, 4, 0, 0],
          color: "#8DE4F3",
        },
        markLine: {
          symbol: "none",
          data: [
            {
              yAxis: avg, //警戒线在y轴的坐标
            },
          ],
          silent: true,
          label: {
            show: true,
            color: "#8DE4F3",
            fontSize: 14,
            padding: [0, 0, 0, 0], // 重点在这里，这个地方就是定位
            position: "end",
            formatter: `行业均值\n    ${avg && Number(avg).toFixed(2)}`,
          },
        },
      },
    ],
  };
}

// 对89这家厂做特殊处理
function is89SpecialHandle (array) {
  if (Array.isArray(array) && array.length >= 3) {
    if (array[0] > array[1]) {
      array[0] = array[1]
    }
    if (array[1] > array[2]) {
      array[2] = array[1]
    }
  }
}
export default getOpt;
